import React, { useEffect, useState } from "react";
import styles from "./newuserModal.module.css";
import { useNavigate } from "react-router-dom";

const TRANSITION_MS = 200;

const NewUserPopup = ({
  // mount control
  isOpen = false, // usually showGuideCard || showWelcomeCard
  // which cards to show
  showGuideCard = false, // “To get started”
  openPopup,
  showWelcomeCard = false, // “Welcome to CUPI”
  // independent close handlers
  onCloseGuide = () => {}, // close only the guide card
  onCloseWelcome = () => {}, // close only the welcome card
  // overlay close (close both by default)
  onOverlayClose, // optional; if not provided, closes both
  onProceed = () => {},
  mascotSrc,
}) => {
  // keep mounted long enough to play close animation
  const [render, setRender] = useState(isOpen);
  const [success, setSuccess] = useState(false);
  const [CLickec, setClicked] = useState(false);
  const [phase, setPhase] = useState(isOpen ? "open" : "close"); // "open" | "close"
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      setRender(true);
      requestAnimationFrame(() => setPhase("open"));
    } else {
      setPhase("close");
      const t = setTimeout(() => setRender(false), TRANSITION_MS);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  // lock scroll + ESC
  useEffect(() => {
    if (!render) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") {
        // ESC closes the top-most first; tweak as needed
        if (showWelcomeCard) onCloseWelcome();
        else if (showGuideCard) onCloseGuide();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [render, showGuideCard, showWelcomeCard, onCloseGuide, onCloseWelcome]);

  if (!render) return null;

  const isOpening = phase === "open";
  const handleOverlay = () => {
    if (onOverlayClose) return onOverlayClose();
    // default: close both if open
    if (showWelcomeCard) onCloseWelcome();
    if (showGuideCard) onCloseGuide();
  };

  return (
    <>
      <div
        className={`${styles.overlay} ${
          isOpening ? styles.isOpen : styles.isClosing
        }`}
      />

      {CLickec && (
        <div
          className={styles.popupcontainer0}
          role="dialog"
          aria-modal="true"
          aria-labelledby="guideTitle"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={`${styles.popupcontainer1} ${styles.guideCard} ${
              isOpening ? styles.cardOpen : styles.cardClose
            }`}
          >
            <div className={styles.popupcontainer1HeaderContainer0}>
              <div id="guideTitle" className={styles.popupcontainer1Header0}>
                <strong>Adding a CUPI Admin or User</strong>
              </div>

              <button
                type="button"
                className={styles.closeBtn}
                onClick={onCloseGuide} // ← closes only this one
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className={styles.popupcontainerContent}>
              <ol className={styles.bullets}>
                <li>
                  Add the Name as per PAN, the Phone number and email. CUPI
                  Dashboard and CUPI app can be accessed only with the Phone
                  number you add here
                </li>
                <li>Add a few tags and click the “+” button.</li>
                <li>Set the transaction limits next.</li>
                <li>
                  Set The roles: Select “Admin” to give access to CUPI
                  Dashboard. To Pay with CUPI App - select “App User”. For
                  Dashboard view-access only, select “Dashboard Viewer”
                </li>{" "}
                <li>
                  Finally, Click Submit to send the KYC request to the employee.
                </li>{" "}
                <li>
                  Once the KYC is done, download our CUPI app and start
                  spending!
                </li>
              </ol>
            </div>
          </div>
        </div>
      )}

      {/* WELCOME MODAL */}
      {showWelcomeCard && (
        <div
          className={styles.popupcontainer}
          role="dialog"
          aria-modal="true"
          aria-labelledby="welcomeTitle"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={`${styles.popupcontainer1} ${
              isOpening ? styles.cardOpen : styles.cardClose
            }`}
          >
            <div className={styles.popupcontainer1HeaderContainer}>
              <div id="welcomeTitle" className={styles.popupcontainer1Header}>
                Welcome to CUPI
              </div>

              <button
                type="button"
                className={styles.closeBtn}
                onClick={() => {
                  onCloseWelcome();
                  onOverlayClose();
                }} // ← closes only this one
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <p className={styles.subhead}>
              We are thrilled to have you Onboard!
            </p>
            <div className={styles.popupcontainerContent}>
              <ol className={styles.bullets}>
                <li>Let’s begin!</li>
                <li>
                  Add your employees here. We’ll send them a KYC link, and once
                  their KYC is done, they can download the CUPI app and start
                  spending.
                </li>
                <li>
                  Validate your Company Bank account to load money into your
                  CUPI wallet.
                </li>
                <li>Happy Spending!</li>
              </ol>

              <div className={styles.ctaRow}>
                <button
                  type="button"
                  className={styles.cta}
                  onClick={() => {
                    // openPopup();
                    setClicked(true);
                    onCloseWelcome();
                  }}
                >
                  Add your first CUPI User
                </button>
              </div>

              <p className={styles.subhead1}>
                <span className={styles.bold}>Note:</span> Complete your Advance
                KYC to unlock unlimited spending from your CUPI wallet.
              </p>

              <div className={styles.mascotWrap}>
                {mascotSrc ? (
                  <img
                    className={styles.mascot}
                    src="/cupiImg.svg"
                    alt="CUPI mascot"
                    draggable="false"
                  />
                ) : (
                  <div className={styles.mascotPlaceholder} aria-hidden />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewUserPopup;
